<template>
  <div
    class="absolute top-8 md:top-16 right-0 flex flex-col items-end z-1 xs-l:hidden"
  >
    <Button
      v-if="unibuddy && options.activate_unibuddy"
      type="button"
      title="Open Unibuddy chat (opens in modal)"
      icon="ChatIcon"
      iconsize="16px"
      data-gtm-unibuddy-btn
      class="flex-c bg-accent-1 h-10 w-12 pr-4 mb-3 shadow-xl focus-b"
      @buttonClick="$store.commit('toggleUnibuddyState')"
    />

    <Button
      v-show="showTourMapToggle"
      type="button"
      title="Show location on map (opens in popup)"
      icon="LocationIcon"
      iconsize="18px"
      data-gtm-tour-map-btn
      class="flex-c bg-accent-1 h-10 w-12 pr-4 mb-3 shadow-xl focus-b"
      @buttonClick="$store.commit('toggleTourMapState')"
    />

    <div v-if="options.activate_announcements" class="relative flex">
      <Button
        id="announcement-toggle"
        type="button"
        :title="
          showInfoTab
            ? 'Close announcements'
            : 'Open announcements (opens slideout panel)'
        "
        aria-controls="announcements-pannel"
        aria-expanded="showInfoTab"
        text="i"
        textsize="3xl"
        data-gtm-announcements-btn
        class="flex-c bg-accent-1 h-10 w-12 pb-1 pr-4 text-white font-serif shadow-xl focus-b"
        @buttonClick="$store.commit('toggleInfoTabState')"
      />
      <Transition name="fade">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" v-show="showUnseenAnnouncementsAlert" v-bind:svg-inline="''" v-bind:class="'absolute top-0 left-0 -mt-4 -ml-4 h-8 w-8'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Group 3526" transform="translate(-1281 -78)"><g data-name="Group 3525"><circle data-name="Ellipse 270" cx="20" cy="20" r="20" transform="translate(1281 78)" fill="#f4aa00" opacity=".299"/></g><circle data-name="Ellipse 269" cx="17" cy="17" r="17" transform="translate(1284 81)" fill="#f4aa00" opacity=".299"/><circle data-name="Ellipse 268" cx="14" cy="14" r="14" transform="translate(1287 84)" fill="#f4aa00"/><text data-name="!" transform="translate(1298 105)" fill="#00325f" font-size="20" font-family="SourceSansPro-Semibold, Source Sans Pro" font-weight="600"><tspan x="0" y="0">!</tspan></text></g></svg>
      </Transition>
      <section
        id="announcements-pannel"
        :inert="!showInfoTab"
        :aria-hidden="!showInfoTab"
        class="h-24 bg-accent-1 transition"
        :class="[showInfoTab ? 'w-68 md:w-96' : 'w-0']"
      >
        <Announcements
          :class="{ hidden: !showInfoTab }"
          @showUnseenAnnouncementsAlert="handleUnseenAnnouncements"
        />
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/buttons/Button.vue'
import Announcements from '@/components/Announcements.vue'

export default {
  name: 'BtnsExtra',

  components: {
    Button,
    Announcements
  },

  props: {
    post: {
      type: [Object, Boolean],
      default: () => {}
    }
  },

  data() {
    return {
      showUnseenAnnouncementsAlert: false
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'showInfoTab', 'isTour']),
    ...mapGetters(['unibuddy', 'options']),

    showTourMapToggle() {
      return this.isTour && this.post?.coordinates?.lat
    }
  },

  methods: {
    handleUnseenAnnouncements(value) {
      this.showUnseenAnnouncementsAlert = value
    }
  }
}
</script>
